(function() {

    'use strict';

    /**
     * VHAB global config object.
     *
     * Provides setter and getter and interface for later-loaded angular
     * AB config services.
     *
     * This gets added to the page immediately, and is picked up
     * by the ABConfig service when it is created.
     */

     var VHAB = function (win) {
        var vhab = {
            config: {},
            _onSetConfig: function(param, value) {},
            _onGetConfig: function(param, inValue) { return inValue; }
        };

        /**
         * Set a config param to the given value.
         *
         * @param param String Name of the parameter to set
         * @param value {*} The value of the parameter. String, number, object, anything.
         * @param noReplace Boolean Optional flag to prevent replacement of existing parameter of same name
         */
        vhab.setConfig = function(param, value, noReplace) {
            if (!noReplace || vhab.config[param] === undefined) {
                vhab.config[param] = value;
                vhab._onSetConfig(param, value);
            }
        };

        /**
         * Get a configuration parameter
         *
         * @param param String name of the parameter
         * @return {*} The parameter value
         */
        vhab.getConfig = function(param) {
            return vhab._onGetConfig(param, vhab.config[param]);
        };

        // Install new VHAB or return existing one if already in the page
        if (win.VHAB) {
            return win.VHAB;
        } else {
            win.VHAB = vhab;
            return vhab;
        }
    };

    // Init as early as possible
    VHAB(window);

    angular.module('vhols-ab-config')
        .factory('ABConfig', ['$window', 'ipCookie', 'AB_CONST', '$rootScope', function($window, ipCookie, AB_CONST, $rootScope) {

            var abConfig = {
                    config: {}
                };

            /**
             * Get a configuration value by name
             * @param configName string The name of the config param to retreive
             * @return {*} The configuration value or undefined if not defined
             */
            abConfig.get = function(configName) {
                return abConfig.config[configName];
            };

            /**
             * Set a configuration value by name
             * @param configName string Name of this configuration value
             * @param configValue {*} The value to set.  Can be any type.
             */
            abConfig.set = function(configName, configValue) {
                abConfig.config[configName] = configValue;
                hasChanged(configName, configValue);
            };

            /**
             * To be called when a config value has changed. Here to use as hook function
             * for VHAB._onSetConfig and when abConfig.set is called, to cause an event to
             * be broadcasted on the root scope.
             * @param configName {string} Config variable name
             * @param configValue {*} New config value
             */
            function hasChanged(configName, configValue) {
                $rootScope.$broadcast(AB_CONST.PREFIX + configName, configValue);
            }

            /**
             * Initialise config from cookies.
             *
             * Looks for cookies with AB.PREFIX (normally `vhab.`) and brings
             * the values into the config (but does NOT replace existing config paramters
             * if they already exist.  This allows in-page settings to override cookies.
             *
             * @param vhab {object} global VHAB object reference
             */
            function initFromCookies(vhab) {
                var cookies;

                try {
                    cookies = ipCookie();
                } catch (e) {
                    cookies = {};
                }

                angular.forEach(cookies, function(value, key) {
                    if (key.indexOf(AB_CONST.PREFIX) === 0) {
                        vhab.setConfig(key.substring(AB_CONST.PREFIX.length), value, true);
                    }
                });
            }

            /**
             * Initialise config from URL parameters.
             *
             * Looks for URL parameters with AB.PREFIX (normally `vhab.`) and brings
             * the values into the config (but does NOT replace existing config parameters
             * if they already exist.  This allows in-page settings to override URL params.
             *
             * @param vhab {object} global VHAB object reference
             */
            function initFromParams(vhab) {
                var params;

                try {
                    params = $window.location.search.substring(1).split('&');
                } catch (e) {
                    params = [];
                }

                angular.forEach(params, function(value) {
                    var kv = value.split('=');

                    if (kv[0].indexOf(AB_CONST.PREFIX) === 0) {
                        var val =  decodeURIComponent(kv[1]);

                        try {
                            val = JSON.parse(val);
                        } finally {
                            vhab.setConfig(kv[0].substring(AB_CONST.PREFIX.length), val, true);
                        }
                    }
                });
            }

            // Install or fetch global object
            var vhab = VHAB($window);

            // Use global config
            abConfig.config = vhab.config;

            // Init from Cookies and Params
            // Params first, because they override cookies
            initFromParams(vhab);
            initFromCookies(vhab);

            // hook up change interest
            vhab._onSetConfig = function(configName, configValue) {
                hasChanged(configName, configValue);
            };

            return abConfig;
        }]);
})();
